export default __webpack_public_path__ + "TG-afl-SM-1000w.2b8eb4a.png";